import { render } from "./ChatProviderCard.vue?vue&type=template&id=0e4fa722&scoped=true"
import script from "./ChatProviderCard.vue?vue&type=script&lang=js"
export * from "./ChatProviderCard.vue?vue&type=script&lang=js"

import "./ChatProviderCard.vue?vue&type=style&index=0&id=0e4fa722&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0e4fa722"]])

export default __exports__